import { render, staticRenderFns } from "./ChallengingQuestions.vue?vue&type=template&id=1558614d"
import script from "./ChallengingQuestions.vue?vue&type=script&lang=js"
export * from "./ChallengingQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports